module.exports = __webpack_public_path__ + "img/ccflowRightNextAdmin.fda9c792.png";